export default __webpack_public_path__ + "static/media/Logo_2_2.c4cbca76.png";